$(function() {

  // если блока нет на странице, то код дальше можно не выполнять.
  if ($('.about_user_text').length === 0) return;

  //$('.about_user_text a').attr('target', '_blank');

});
